var $ = require('jquery');
var asimov = require('@99designs/asimov-core').default;
var PromoBar = require('./lib/promo-bar-lib');

var pluginName = 'promoBar';
var promoBars = {};
var defaults = {
    cookieName: '',
    cookieDays: 1,
    cookiePrefix: '',
    dismissSelector: '[data-promo-bar-dismiss]'
};

function build(options, elem) {

    var obj = new PromoBar().init(options, elem);

    // Public API
    return {

        show: function() {
            obj.show();
            return this;
        },

        hide: function() {
            obj.hide();
            return this;
        }

    };
}

// Plugin definition
$.fn[pluginName] = function(options) {
    return this.each(function() {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData(
                $(this),
                pluginName,
                $.extend(true, {}, defaults, options)
            );

            $.data(this, pluginName, build(opts, this));
        }
    });
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov-promo-bar/index.js